














































import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { QueryGoodsList, BatchAddActivityGoods, QuerySupplierList,QueryAllShopNameList } from '@/api'
import { Message, MessageBox } from 'element-ui'
import { ElForm } from 'element-ui/types/form'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { PriceFormat } from '@/utils/tyepconvert'
import { getNameById } from '@/store/classifyStore'
import constant from '@/utils/constant'
import {GoodsStatusFormat} from '@/utils/tyepconvert'

@Component({
  components: { VTable, VQuery },
})
export default class UpdateActivityGoodsDialog extends Vue {
  @Emit('close')
  private close() {
    this.show = false
    this.data = []
    this.activity = {}
    this.tableData = []
    this.tableCurrntPage = 1
    this.tableTotal = 0
  }
  public open(data: any) {
    this.show = true
    this.activity = data
    this.loadData()
  }
  private show = false
  private activity: any = {}
  private data: Array<any> = []
  private shopIdOption: Array<any> = []
  private tableTotal = 0
  private queryParam = {
    startRow: 0,
    limit: 10,
  }
  private tableData = []
  private tableCurrntPage = 1

  private supplierOption: Array<any> = []
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}
    private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption}

  // 查询条件
  private queryModels: Array<QueryModel> = [
    // this.supplierQueryParam,
    this.shopIdQueryParam,
    { title: '商品名称', param: 'goodsName' },
    { title: '状态', param: 'goodsStatus', type:"select",selectData:constant.GoodsStatus },
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = []
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '序号', param: 'id', type: 'index' },
    // { title: '供应商编号', param: 'supplierCode' },
    { title: '店铺', param: 'shopId',formatter: this.shopNameForam, overflow: true },
    { title: '商品图片', param: 'goodsBanners' , width: 80 , type:'image', formatter: this.getGoodsBanner },
    { title: '商品名称', param: 'goodsName' },
    { title: '销售价', param: 'showPrice' ,formatter: this.showPriceFormat},
    // { title: '一级分类', param: 'goodsOneClassifyId', formatter: getNameById },
    // { title: '二级分类', param: 'goodsTwoClassifyId', formatter: getNameById },
    // { title: '单位', param: 'goodsUnit' },
    // { title: '销售金额', param: 'salesIntegral', formatter: PriceFormat },
    // { title: '奖励积分', param: 'rewardIntegral', formatter: PriceFormat },
    { title: '库存', param: 'inventory' },
    { title: '状态', param: 'goodsStatus', formatter: GoodsStatusFormat},
    {
      title: '操作',
      operation: [{ title: '绑定', click: this.addGoods }],
    },
  ]

  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }

  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  public async loadData() {
    const param = { ...this.queryParam }
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 5)
    const result = await QueryGoodsList(param)
    this.tableData = result.list
    this.tableTotal = result.total
  }

  public search() {
    this.loadData()
    // this.loadSupplier()
  }

  public created(){
    this.loadShop()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  private getGoodsBanner(value: string){
    if(value){
      const vs = value.split(",")
      console.log("vs")
      console.log(vs)
      return vs[0]
    }
    return ""
  }
  
  // 显示价格
  private showPriceFormat(v:any,row:any){
    let showPrice = ''
    if(row.minPrice == row.maxPrice){
      showPrice = PriceFormat(row.minPrice)
    } else {
      showPrice = PriceFormat(row.minPrice) + '~' + PriceFormat(row.maxPrice)
    }
    return showPrice
  }

  public removeGoods(data:any){

    this.data = this.data.filter(e=>e.goodsCode != data.goodsCode)

  }
  public addGoods(data: any) {
    const t = this.data.filter(e=>e.goodsCode == data.goodsCode)
    if(t.length > 0){
      return
    }
    const row = {
      activityId: this.activity.id,
      activityType: this.activity.activityType,
      startTime: this.activity.startTime,
      endTime: this.activity.endTime,
      goodsCode: data.goodsCode,
      goodsName: data.goodsName,
      salesIntegral: (data.salesIntegral / 100),
      activitySalesIntegral: (data.salesIntegral / 100),
      rewardIntegral: (data.rewardIntegral / 100),
      activityReturnIntegral: (data.rewardIntegral / 100),
      sort: data.sort,
      activitySort: 0,
      activityInventory: -1,
      goodsInventory: data.inventory,
      minPrice: data.minPrice,
      maxPrice: data.maxPrice ,
      goodsBanners: data.goodsBanners ,
      shopId: data.shopId
    }
    
    this.data.push(row)
  }

  public async save() {
    this.data.map((ag: any) => {
      ag.salesIntegral = ag.salesIntegral * 100
      ag.activitySalesIntegral = ag.activitySalesIntegral * 100
      ag.rewardIntegral = ag.rewardIntegral * 100
      ag.activityReturnIntegral = ag.activityReturnIntegral * 100
      ag.sort = ag.activitySort
      ag.inventory = ag.activityInventory
    })

    BatchAddActivityGoods({ activityGoodsList: this.data }).then(res=>{
      this.close()
    })
    
  }
}
